export const pipelineStatusEnum = (state) => state.pipelineStatusEnum
export const pipelineFeelingEnum = (state) => state.feelings
export const pipelinePriorityEnum = (state) => state.pipelinePriorityEnum
export const pipelineHistoryContextEnum = (state) => state.pipelineHistoryContextEnum
export const pipelineStates = (state) => state.pipelineStates
export const getCurrentPipeline = (state) => state.currentPipeline
export const getPipelines = (state) => state.pipelines
export const getActivePipelines = (state) => state.activePipelines
export const getSalesPersons = (state) => state.salesPersons
export const getActivityRemindEnum = (state) => state.activityRemindEnum